import PouchDB from 'pouchdb'
import { actualizar, guardar } from '../formulario/src/components/serverComponent/api'


export const db_alfanumerica = new PouchDB('Informacion_alfanumerica')

//obtener registro por id
export function getOne(id) {
    return db_alfanumerica.get(id)
}

//obtener todos los registros de la bd
export function getAll() {
    return db_alfanumerica.allDocs({
        include_docs: true,
        attachments: true
    })
}

export function getRegistroByCodCat(codigo, id_form) {

    return db_alfanumerica.allDocs({
        include_docs: true,
        attachments: true
    }).then((docs) => {
        let respuesta = []
        let fila = docs.rows
        for (let i = 0; i < fila.length; i++) {
            if (codigo == fila[i].doc.num_pre && id_form == fila[i].doc.id_form) {
                respuesta.push(fila[i].doc)
            }
        }
        return respuesta
    })
}


// el sw no tiene acceso a las variables definidas en update-var
///guardar el token en bd local para usarlo al sincronizar
// export function almacenarToken(variable, id) {
export function almacenarVariable(variable, id) {
    let obj = {
        _id: id,
        atributo: variable
    }
    getOne(id).then(doc => {
        obj._id = obj._id
        obj._rev = doc._rev
        db_alfanumerica.put(obj)
    }).catch(e => {
        db_alfanumerica.put(obj).then(res => { console.log('almacenado') })
    })
}


//guardar informacion alfanumerica en bd local
export function guardarFormulario(respuesta) {
    respuesta._id = respuesta.cod_cat + '_' + respuesta.id_form;   //cambiar dependiendo necesidad  id para identificar valor 
    respuesta.subido = 'No'              //variable para identificar que no se ha subido la información
    respuesta.t_id = respuesta.cod_cat;

    return getOne(respuesta._id).then(doc => {
        //busca por id si existe se modifica        
        respuesta._id = respuesta._id;
        respuesta._rev = doc._rev;
        respuesta.key = doc.key;
        respuesta.id_data = doc.id_data ? doc.id_data : doc.t_id;
        respuesta.t_id = doc.id_data ? doc.id_data : doc.t_id;

        if (doc.estado_captura == 'rechazado') {
            respuesta.estado_captura = 'actualizar'
        }    //         
        return db_alfanumerica.put(respuesta).then(() => {
            self.registration.sync.register('nuevo-post');
            const newResp = { ok: true, offline: true };
            return new Response(JSON.stringify(newResp));
        }).catch(e => console.log(e))

    }).catch(e => {
        console.log(e)
        return db_alfanumerica.put(respuesta).then(() => {
            self.registration.sync.register('nuevo-post');
            const newResp = { ok: true, offline: true };
            return new Response(JSON.stringify(newResp));
        });
    })
}

//guardar informacion alfanumerica en bd local
export function guardarRechazados(respuesta, id_form) {
    respuesta._id = respuesta.t_id + '_' + id_form;   //cambiar dependiendo necesidad  id para identificar valor 
    respuesta.subido = 'No'
    respuesta.id_form = id_form

    return getOne(respuesta._id).then(doc => {
        //busca por id si existe se modifica
        respuesta._id = respuesta._id
        respuesta._rev = doc._rev
        respuesta.key = doc.key
        respuesta.id_data = doc.id_data

        return db_alfanumerica.put(respuesta).then(() => {
            const newResp = { ok: true, offline: true };
            return new Response(JSON.stringify(newResp));
        }).catch(e => console.log(e))

    }).catch(e => {
        console.log(e)
        return db_alfanumerica.put(respuesta).then(() => {
            const newResp = { ok: true, offline: true };
            return new Response(JSON.stringify(newResp));
        });
    })
}

// Postear mensajes a la API
export function postearRespuestas() {
    const posteos = [];
    return db_alfanumerica.allDocs({ include_docs: true }).then(docs => {
        docs.rows.forEach(row => {
            const doc = row.doc;
            if (!doc.atributo) {
                if (doc.estado_captura && doc.estado_captura == 'actualizar' && doc.subido != 'Si') {
                    doc.estado_captura = ''
                    doc.id_data = doc.cod_cat
                    var form_data = new FormData();
                    for (var key in doc) {
                        form_data.append(key, doc[key]);
                    }

                    getOne('token').then((res) => {
                        getOne('codigo-municipio').then((mun) => {
                            let cod_mun = mun.atributo
                            let token = res.atributo
                            const Api_Actualizar = actualizar(doc.id_form, doc.id_data, form_data, token, cod_mun)
                            Api_Actualizar.then(function (response) {
                                self.registration.sync.register('creado');
                                if (response.statusText == 'OK' || response.status == 200) {
                                    // console.log(doc)
                                    doc.subido = 'Si'
                                    db_alfanumerica.put(doc)
                                }
                                return doc
                            }).catch(function (e) {
                                doc.estado_captura = 'actualizar'
                                doc.subido = 'No'
                                db_alfanumerica.put(doc)
                                console.log('error')
                            })
                            posteos.push(Api_Actualizar);
                        })

                    })



                } else if (doc.subido != 'Si' && doc.estado_captura != 'rechazado') {
                    var form_data = new FormData();

                    for (var key in doc) {
                        form_data.append(key, doc[key]);
                    }
                    getOne('token').then((res) => {
                        getOne('codigo-municipio').then((mun) => {
                            let cod_mun = mun.atributo
                            let token = res.atributo
                           
                            const Api_Guardar = guardar(form_data, doc.id_form, token, cod_mun);
                            Api_Guardar.then(function (response) {
                                self.registration.sync.register('creado');
                                
                                if (response.status == 200) {
                                    // console.log(doc)
                                    doc.subido = 'Si'
                                    db_alfanumerica.put(doc)
                                }
                                return doc
                            }).catch(e => {
                                self.registration.sync.register('nuevo-post');
                            })
                            posteos.push(Api_Guardar);
                        })

                    })
                }
            }

        }); // fin del foreach

        return Promise.all(posteos);

    });
}

////////
export function guardarReferenciaOnline(formdata) {
    var object = {};
    formdata.forEach(function (value, key) {
        object[key] = value;
    });

    object._id = object.cod_cat + '_' + object.id_form
    object.subido = 'Si'
    object.id_data = object.id_data
    object.t_id = object.id_data
    // console.log(object._id)

    getOne(object._id).then((doc) => {
        object._id = doc._id
        object._rev = doc._rev
        object.key = doc.key
        object.id_data = doc.id_data
        object.t_id = object.id_data
        object.estado_captura = ''

        db_alfanumerica.put(object)
    }).catch((e) => {
        db_alfanumerica.put(object)
    })

}